/**
 * Formats a Date to HH:MM string for time input.
 */
export const formatTimeInput = (date: Date): string => {
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

/**
 * Parses time input (HH:MM or HH:MM:SS) to create a Date object.
 * If time contains seconds, the seconds parameter is ignored.
 */
export const parseTimeInput = (time: string, seconds: string, baseDate: Date): Date => {
  const parts = time.split(':').map(Number);
  const hours = parts[0];
  const minutes = parts[1];
  const secs = parts.length >= 3 ? parts[2] : (parseInt(seconds, 10) || 0);
  const result = new Date(baseDate);
  result.setHours(hours, minutes, secs, 0);
  return result;
};

/**
 * Validates and formats seconds input (0-59).
 * Returns formatted string or null if invalid.
 */
export const validateSecondsInput = (value: string): string | null => {
  const numValue = value.replace(/\D/g, '');
  const num = parseInt(numValue, 10);
  if (numValue === '' || (num >= 0 && num <= 59)) {
    return numValue.slice(0, 2);
  }
  return null;
};

/**
 * Calculates time spent in seconds between two dates.
 */
export const calculateTimeSpent = (startDate: Date, endDate: Date): number => {
  return Math.floor((endDate.getTime() - startDate.getTime()) / 1000);
};
